export const NO_QUALIFICATION_VALUE = "-";
export const NO_QUALIFICATION_LABEL = "Sans qualification";

export function formatGoogleGroupQualification(value: string): string {
  return value === NO_QUALIFICATION_VALUE ? NO_QUALIFICATION_LABEL : value;
}
